export default __webpack_public_path__ + "static/Денежный поток 9-8627d2ce0adce5f1df26deefef5d28de.jpg";